// import React from "react";
// import { Formik, Form } from "formik";
// import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// import { useNavigate } from "react-router";
// import { useLocation } from "react-router-dom";
// import * as Yup from "yup";
// import { Button, Grid } from "@mui/material";
// import FIelds from "../../uicomponents/FIelds";
// import { Notification } from "../../utils/Notification";
// import API from "../../utils/Axios.utils";

// const EditSkill = () => {
//   const navigate = useNavigate();
//   // Snackbar
//   const [alert, setAlert] = React.useState(false);
//   const [alertContent, setAlertContent] = React.useState("");
//   const [alertType, setAlertType] = React.useState("");

//   //   skillDetails
//   const location = useLocation();
//   const skillDetails = location.state?.skillDetails;

//   console.log("skillDetails", skillDetails);

//   const handleAlert = () => {
//     setAlert(false);
//   };

//   const initialValues = { skill_name: skillDetails.skill_name };

//   const token = JSON.parse(localStorage.getItem("userLoggedIn")).token;

//   const config = {
//     headers: { Authorization: `Bearer ${token}` },
//   };

//   const onSubmit = async (values) => {
//     try {
//       const res = await API.put(
//         `/api/skill/${skillDetails.skill_id}`,
//         values,
//         config
//       );
//       setAlertContent(res?.data?.message);
//       setAlertType("success");
//       setAlert(true);
//       setTimeout(() => {
//         navigate("/skills");
//       }, 1500);
//     } catch (error) {
//       setAlertContent(error?.response?.data?.message);
//       setAlertType("error");
//       setAlert(true);
//     }
//   };
//   const validationSchema = Yup.object().shape({
//     skill_name: Yup.string()
//       .min(2, "Minimum 2 characters are required.")
//       .max(50, "Maximum length is 50 characters.")
//       .matches(
//         /^[a-zA-Z]+(\s[a-zA-Z]+)*$/,
//         "Invalid skill name format.Spaces at the start and end are not allowed."
//       )
//       .required("This field is required."),
//   });

//   const navigateToPreviousPage = () => {
//     navigate(-1);
//   };

//   return (
//     <div style={{ marginTop: 20 }}>
//       <Button startIcon={<ArrowBackIcon />} onClick={navigateToPreviousPage}>
//         Back
//       </Button>
//       <div
//         style={{
//           border: "1px solid #989898",
//           borderRadius: "10px",
//           padding: "15px",
//         }}
//       >
//         <div
//           style={{
//             fontFamily: "Roboto, Helvetica, Arial, sans-serif",
//             fontSize: "20px",
//             fontWeight: "500",
//             letterSpacing: 1,
//             textAlign: "left",
//           }}
//         >
//           <span>Edit Skill</span>
//           <div style={{ display: "grid" }}>
//             <Formik
//               initialValues={initialValues}
//               onSubmit={onSubmit}
//               validationSchema={validationSchema}
//             >
//               {(props) => (
//                 <Form noValidate>
//                   <Grid container spacing={2}>
//                     <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
//                       <span style={{ fontSize: "16px" }}>Skill Name</span>
//                       <FIelds name="skill_name" props={props} />
//                     </Grid>

//                     {/* Submit */}
//                     <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
//                       <div
//                         style={{
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: "center",
//                         }}
//                       >
//                         <Button
//                           variant="contained"
//                           aria-haspopup="true"
//                           style={{
//                             background: "#2777AA",
//                             fontFamily: "Roboto, Helvetica, Arial, sans-serif",
//                             fontSize: "16px",
//                             fontWeight: "500",
//                             letterSpacing: 1,
//                           }}
//                           type="submit"
//                         >
//                           Submit
//                         </Button>
//                       </div>
//                     </Grid>
//                   </Grid>
//                   <Notification
//                     message={alertContent}
//                     open={alert}
//                     severity={alertType}
//                     onClose={handleAlert}
//                   />
//                 </Form>
//               )}
//             </Formik>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default EditSkill;


// import React from "react";
// import { Formik, Form } from "formik";
// import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// import { useNavigate, useLocation } from "react-router-dom";
// import * as Yup from "yup";
// import { Button, Grid, Chip } from "@mui/material";
// import CloseIcon from "@mui/icons-material/Close";
// import { Notification } from "../../utils/Notification";
// import API from "../../utils/Axios.utils";

// const EditSkill = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const skillDetails = location.state?.skillDetails || {};
//   console.log("skillDetails :- ", skillDetails);

//   const [alert, setAlert] = React.useState(false);
//   const [alertContent, setAlertContent] = React.useState("");
//   const [alertType, setAlertType] = React.useState("");

//   const handleAlert = () => {
//     setAlert(false);
//   };

//   const initialValues = {
//     coreSkillId: skillDetails.id?.toString() || "",
//     techSkillsInput: "",
//     techSkills: (skillDetails.techSkills || []).map((skill) => skill.name),
//   };

//   const validationSchema = Yup.object().shape({
//     techSkillsInput: Yup.string(),
//     techSkills: Yup.array().min(1, "At least one tech skill required"),
//   });

//   const onSubmit = async (values, { setSubmitting }) => {
//     try {
//       const newTechSkills = values.techSkillsInput
//         ? values.techSkillsInput
//           .split(",")
//           .map((t) => t.trim())
//           .filter((t) => t)
//         : [];

//       const updatedTechSkillsSet = new Set([...values.techSkills, ...newTechSkills]);
//       const updatedTechSkills = Array.from(updatedTechSkillsSet);

//       const payload = {
//         coreSkillId: values.coreSkillId,
//         techSkills: updatedTechSkills,
//       };

//       const token = JSON.parse(localStorage.getItem("userLoggedIn")).token;
//       const config = {
//         headers: { Authorization: `Bearer ${token}` },
//       };

//       const res = await API.put(`/api/tech-skill/${skillDetails.id}`, payload, config);

//       setAlertContent(res?.data?.message || "Tech skills updated successfully");
//       setAlertType("success");
//       setAlert(true);

//       setTimeout(() => {
//         navigate("/skills");
//       }, 1500);
//     } catch (error) {
//       setAlertContent(error?.response?.data?.message || "Failed to update tech skills");
//       setAlertType("error");
//       setAlert(true);
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   const handleDeleteChip = (chipToDelete, techSkills, setFieldValue) => {
//     const newTechSkills = techSkills.filter((tech) => tech !== chipToDelete);
//     setFieldValue("techSkills", newTechSkills);
//   };

//   const navigateToPreviousPage = () => {
//     navigate(-1);
//   };

//   return (
//     <div style={{ marginTop: 20 }}>
//       <Button startIcon={<ArrowBackIcon />} onClick={navigateToPreviousPage}>
//         Back
//       </Button>
//       <div
//         style={{
//           border: "1px solid #989898",
//           borderRadius: 10,
//           padding: 15,
//         }}
//       >
//         <div
//           style={{
//             fontFamily: "Roboto, Helvetica, Arial, sans-serif",
//             fontSize: 20,
//             fontWeight: 500,
//             letterSpacing: 1,
//             textAlign: "left",
//           }}
//         >
//           <span>Edit Skill</span>
//           <div style={{ display: "grid", marginTop: 10 }}>
//             <Formik initialValues={initialValues} onSubmit={onSubmit} validationSchema={validationSchema}>
//               {(props) => (
//                 <Form noValidate>
//                   <Grid container spacing={2}>
//                     <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
//                       <span style={{ fontSize: 16 }}>Core Skill</span>
//                       <input
//                         type="text"
//                         name="coreSkillName"
//                         value={skillDetails.name || ""}
//                         disabled
//                         style={{
//                           width: "100%",
//                           padding: 8,
//                           backgroundColor: "#f0f0f0",
//                           marginBottom: "24px" // extra space below core skill input
//                         }}
//                       />
//                     </Grid>
//                     <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
//                       <span style={{ fontSize: 16 }}>Add Technical Skills (comma separated)</span>
//                       <input
//                         type="text"
//                         name="techSkillsInput"
//                         placeholder="e.g. ReactJs, Fast API, MySQL"
//                         value={props.values.techSkillsInput}
//                         onChange={props.handleChange}
//                         onBlur={props.handleBlur}
//                         style={{
//                           width: "100%",
//                           padding: 8,
//                           marginBottom: "8px" // small space before chips
//                         }}
//                       />
//                       {props.touched.techSkillsInput && props.errors.techSkillsInput ? (
//                         <div style={{ color: "red", marginTop: 4, fontSize: 14 }}>
//                           {props.errors.techSkillsInput}
//                         </div>
//                       ) : null}

//                       {/* Show Chips here immediately below input */}
//                       <div style={{
//                         marginTop: 12,  // space above chips
//                         minHeight: 40,
//                         display: "flex",
//                         flexWrap: "wrap",
//                         gap: "8px"
//                       }}>
//                         {props.values.techSkills.length === 0 &&
//                           <span style={{ color: "#666" }}>No tech skills added yet</span>
//                         }
//                         {props.values.techSkills.map((skill, index) => (
//                           <Chip
//                             key={index}
//                             label={skill}
//                             onDelete={() => handleDeleteChip(skill, props.values.techSkills, props.setFieldValue)}
//                             color="primary"
//                             size="small"
//                           />
//                         ))}
//                       </div>
//                       {props.touched.techSkills && props.errors.techSkills ? (
//                         <div style={{ color: "red", marginTop: 4, fontSize: 14 }}>
//                           {props.errors.techSkills}
//                         </div>
//                       ) : null}
//                     </Grid>
//                     <Grid item xs={12}>
//                       <div style={{ display: "flex", justifyContent: "center", marginTop: 20 }}>
//                         <Button
//                           variant="contained"
//                           type="submit"
//                           disabled={props.isSubmitting}
//                           style={{
//                             backgroundColor: "#2777AA",
//                             color: "#fff",
//                             fontFamily: "Roboto, Helvetica, Arial, sans-serif",
//                             fontSize: 16,
//                             fontWeight: "500",
//                             letterSpacing: 1,
//                           }}
//                         >
//                           Update
//                         </Button>
//                       </div>
//                     </Grid>
//                   </Grid>

//                   <Notification message={alertContent} open={alert} severity={alertType} onClose={handleAlert} />
//                 </Form>
//               )}
//             </Formik>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default EditSkill;


import React from "react";
import { Formik, Form } from "formik";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate, useLocation } from "react-router-dom";
import * as Yup from "yup";
import { Button, Grid, Chip, DialogActions, TextField, DialogContent, DialogTitle, Dialog } from "@mui/material";
import { Notification } from "../../utils/Notification";
import API from "../../utils/Axios.utils";
import useAuth from "../../hooks/useAuth";

const EditSkill = () => {

  const navigate = useNavigate();
  const { token } = useAuth();
  const location = useLocation();
  const skillDetails = location.state?.skillDetails || {};

  const [alert, setAlert] = React.useState(false);
  const [alertContent, setAlertContent] = React.useState("");
  const [alertType, setAlertType] = React.useState("");

  const handleAlert = () => {
    setAlert(false);
  };

  const initialValues = {
    coreSkillId: skillDetails.id?.toString() || "",
    techSkillsInput: "",
    techSkills: (skillDetails.techSkills || []).map((skill) => skill.name),
  };

  const validationSchema = Yup.object().shape({
    techSkillsInput: Yup.string(),
    techSkills: Yup.array().min(1, "At least one tech skill required"),
  });

  const onSubmit = async (values, { setSubmitting }) => {
    try {
      const payload = {
        coreSkillId: values.coreSkillId,
        techSkills: values.techSkills, // Now always up-to-date with chips
      };

      // const token = JSON.parse(localStorage.getItem("userLoggedIn")).token;
      const config = {
        headers: { Authorization: `Bearer ${token}` },
      };

      const res = await API.put(`/api/tech-skill/${skillDetails.id}`, payload, config);

      setAlertContent(res?.data?.message || "Tech skills updated successfully");
      setAlertType("success");
      setAlert(true);

      setTimeout(() => {
        navigate("/skills");
      }, 1500);
    } catch (error) {
      setAlertContent(error?.response?.data?.message || "Failed to update tech skills");
      setAlertType("error");
      setAlert(true);
    } finally {
      setSubmitting(false);
    }
  };

  // Helper to add new tech skills from input field
  const handleAddTechSkills = (event, techSkills, techSkillsInput, setFieldValue) => {
    if (event) event.preventDefault();
    const newSkills = techSkillsInput
      .split(",")
      .map((t) => t.trim())
      .filter((t) => t && !techSkills.includes(t));
    if (newSkills.length > 0) {
      setFieldValue("techSkills", [...techSkills, ...newSkills]);
      setFieldValue("techSkillsInput", "");
    }
  };

  // Helper to remove chip from techSkills array
  const handleDeleteChip = (chipToDelete, techSkills, setFieldValue) => {
    const newTechSkills = techSkills.filter((tech) => tech !== chipToDelete);
    setFieldValue("techSkills", newTechSkills);
  };

  const navigateToPreviousPage = () => {
    navigate(-1);
  };

  // Inside your EditSkill component state, add:
  const [openEditCoreSkill, setOpenEditCoreSkill] = React.useState(false);
  const [coreSkillName, setCoreSkillName] = React.useState(skillDetails.name || "");

  // Validation schema for editing core skill name:
  const editCoreSkillValidationSchema = Yup.object().shape({
    name: Yup.string()
      .required("Core Skill Name is required")
      .max(50, "Core Skill Name cannot exceed 50 characters")
      .matches(
        /^[a-zA-Z\s]+$/,
        "Core Skill Name must contain only alphabetic characters and spaces."
      ),
  });
  // Handlers to open/close dialog
  const handleOpenEditCoreSkill = () => setOpenEditCoreSkill(true);
  const handleCloseEditCoreSkill = () => setOpenEditCoreSkill(false);
  // API submit handler for editing core skill
  const handleEditCoreSkillSubmit = async (values, { setSubmitting }) => {
    try {
      // const token = JSON.parse(localStorage.getItem("userLoggedIn")).token;
      const config = { headers: { Authorization: `Bearer ${token}` } };
      const payload = { name: values.name };
      const res = await API.put(`/api/core-skill/${skillDetails.id}`, payload, config);

      setAlertContent(res?.data?.message || "Core Skill updated successfully");
      setAlertType("success");
      setAlert(true);

      skillDetails.name = values.name; // update local name used in UI
      setCoreSkillName(values.name);

      handleCloseEditCoreSkill();
    } catch (error) {
      setAlertContent(error?.response?.data?.message || "Failed to update core skill");
      setAlertType("error");
      setAlert(true);
    } finally {
      setSubmitting(false);
    }
  };
  return (
    <div style={{ marginTop: 20 }}>
      <Button startIcon={<ArrowBackIcon />} onClick={navigateToPreviousPage}>
        Back
      </Button>
      <div
        style={{
          border: "1px solid #989898",
          borderRadius: 10,
          padding: 15,
        }}
      >
        <div
          style={{
            fontFamily: "Roboto, Helvetica, Arial, sans-serif",
            fontSize: 20,
            fontWeight: 500,
            letterSpacing: 1,
            textAlign: "left",
          }}
        >
          {/* <span>Edit Skill</span>
          <Button variant="outlined" size="small" onClick={handleOpenEditCoreSkill}>
            Edit Core Skill
          </Button> */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "16px"
            }}
          >
            <span style={{ fontSize: 24, fontWeight: 500 }}>Edit Skill</span>
            <Button
              variant="outlined"
              onClick={handleOpenEditCoreSkill}
              style={{
                fontSize: "16px",
                fontWeight: 400,
                textTransform: "none",
                borderRadius: 6,
                boxShadow: "none"
              }}
            >
              Edit Core Skill
            </Button>
          </div>

          <div style={{ display: "grid", marginTop: 10 }}>
            <Formik initialValues={initialValues} onSubmit={onSubmit} validationSchema={validationSchema}>
              {(props) => (
                <Form noValidate>
                  <Grid container spacing={2}>
                    <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                      <span style={{ fontSize: 16 }}>Core Skill</span>
                      <input
                        type="text"
                        name="coreSkillName"
                        value={skillDetails.name || ""}
                        disabled
                        style={{
                          width: "100%",
                          padding: 8,
                          backgroundColor: "#f0f0f0",
                          marginBottom: "24px"
                        }}
                      />
                    </Grid>
                    <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                      <span style={{ fontSize: 16 }}>Add Technical Skills (comma separated)</span>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <input
                          type="text"
                          name="techSkillsInput"
                          placeholder="e.g. ReactJs, Fast API, MySQL"
                          value={props.values.techSkillsInput}
                          onChange={props.handleChange}
                          onBlur={(e) =>
                            handleAddTechSkills(e, props.values.techSkills, props.values.techSkillsInput, props.setFieldValue)
                          }
                          style={{
                            width: "100%",
                            padding: 8,
                            marginBottom: "8px"
                          }}
                          onKeyDown={e => {
                            if (e.key === "Enter") {
                              handleAddTechSkills(e, props.values.techSkills, props.values.techSkillsInput, props.setFieldValue);
                            }
                          }}
                        />
                        <Button
                          variant="outlined"
                          style={{ marginLeft: 8, marginBottom: "8px", height: "40px" }}
                          onClick={(e) =>
                            handleAddTechSkills(e, props.values.techSkills, props.values.techSkillsInput, props.setFieldValue)
                          }
                        >
                          Add
                        </Button>
                      </div>
                      {props.touched.techSkillsInput && props.errors.techSkillsInput ? (
                        <div style={{ color: "red", marginTop: 4, fontSize: 14 }}>
                          {props.errors.techSkillsInput}
                        </div>
                      ) : null}

                      {/* Show Chips here immediately below input */}
                      <div style={{
                        marginTop: 12,
                        minHeight: 40,
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "8px"
                      }}>
                        {props.values.techSkills.length === 0 &&
                          <span style={{ color: "#666" }}>No tech skills added yet</span>
                        }
                        {props.values.techSkills.map((skill, index) => (
                          <Chip
                            key={index}
                            label={skill}
                            onDelete={() => handleDeleteChip(skill, props.values.techSkills, props.setFieldValue)}
                            color="primary"
                            size="small"
                          />
                        ))}
                      </div>
                      {props.touched.techSkills && props.errors.techSkills ? (
                        <div style={{ color: "red", marginTop: 4, fontSize: 14 }}>
                          {props.errors.techSkills}
                        </div>
                      ) : null}
                    </Grid>
                    <Grid item xs={12}>
                      <div style={{ display: "flex", justifyContent: "center", marginTop: 20 }}>
                        <Button
                          variant="contained"
                          type="submit"
                          disabled={props.isSubmitting || !props.dirty}
                          style={{
                            backgroundColor: (props.isSubmitting || !props.dirty) ? "#ccc" : "#2777AA",
                            color: (props.isSubmitting || !props.dirty) ? "#666" : "#fff",
                            fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                            fontSize: 16,
                            fontWeight: "500",
                            letterSpacing: 1,
                          }}
                        >
                          Update
                        </Button>
                      </div>
                    </Grid>
                  </Grid>
                  <Notification message={alertContent} open={alert} severity={alertType} onClose={handleAlert} />
                  <Dialog 
                    open={openEditCoreSkill} 
                    onClose={(event, reason) => {
                      if (reason && (reason === "backdropClick" || reason === "escapeKeyDown")) {
                        return;
                      }
                      handleCloseEditCoreSkill();
                    }} 
                    fullWidth 
                    maxWidth="xs"
                    PaperProps={{ style: { minWidth: '400px', maxWidth: '400px' } }}
                  >
                    <DialogTitle>Edit Core Skill</DialogTitle>
                    <Formik
                      initialValues={{ name: coreSkillName }}
                      validationSchema={editCoreSkillValidationSchema}
                      onSubmit={handleEditCoreSkillSubmit}
                      enableReinitialize
                    >
                      {(props) => (
                        <Form>
                          <DialogContent dividers>
                            <TextField
                              autoFocus
                              margin="dense"
                              id="name"
                              name="name"
                              label="Core Skill Name"
                              type="text"
                              fullWidth
                              InputProps={{
                                maxLength: 50
                              }}
                              value={props.values.name}
                              onChange={props.handleChange}
                              onBlur={props.handleBlur}
                              error={props.touched.name && Boolean(props.errors.name)}
                              helperText={props.touched.name && props.errors.name}
                            />
                          </DialogContent>
                          <DialogActions>
                            <Button onClick={handleCloseEditCoreSkill} color="secondary">
                              Cancel
                            </Button>
                            <Button type="submit" disabled={props.isSubmitting} color="primary">
                              Save
                            </Button>
                          </DialogActions>
                        </Form>
                      )}
                    </Formik>
                  </Dialog>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditSkill;
